import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import { getPropertyByUid } from 'utils/property/propertyUtils';
import useFetchPropertiesForPropertyCell from './useFetchPropertiesForPropertyCell';

interface PropertyCellProps {
  getValue: () => ScheduledMessage['propertyUid'];
}

const PropertyCell = ({ getValue }: PropertyCellProps) => {
  const { allProperties, isFetching } = useFetchPropertiesForPropertyCell();

  if (isFetching) {
    return <LoadingPlaceholder />;
  }

  const propertyUid = getValue();
  const property = getPropertyByUid(allProperties, propertyUid);

  return property?.name ?? '-';
};

export default PropertyCell;
